import { DATE_DISPLAY_LOCALE } from '../timezone/utils';
/** Mirrors backend `utcDayBounds` in superAgentPortalWithdrawalLimitsService. */
export function getUtcDailyLimitWindow(date = new Date()) {
    const startOfDay = new Date(date);
    startOfDay.setUTCHours(0, 0, 0, 0);
    const endOfDay = new Date(date);
    endOfDay.setUTCHours(23, 59, 59, 999);
    const resetsAt = new Date(startOfDay);
    resetsAt.setUTCDate(resetsAt.getUTCDate() + 1);
    resetsAt.setUTCHours(0, 0, 0, 0);
    return { startOfDay, endOfDay, resetsAt };
}
export function formatUtcDailyLimitWindowLabel(window) {
    const datePart = new Intl.DateTimeFormat(DATE_DISPLAY_LOCALE, {
        month: 'short',
        day: '2-digit',
        year: 'numeric',
        timeZone: 'UTC',
    }).format(window.startOfDay);
    return `${datePart}, 00:00 – 23:59 UTC`;
}
export function formatResetCountdown(msUntilReset) {
    if (msUntilReset <= 0)
        return 'Resets soon';
    const totalMinutes = Math.ceil(msUntilReset / 60000);
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    if (hours > 0) {
        return `Resets in ${hours}h ${minutes}m`;
    }
    return `Resets in ${minutes}m`;
}
export function getUtcDailyLimitResetLabel(now = new Date()) {
    const window = getUtcDailyLimitWindow(now);
    return formatResetCountdown(window.resetsAt.getTime() - now.getTime());
}
